import { inputBaseClasses, outlinedInputClasses, Select, selectClasses, styled } from '@mui/material';

export const StyledSelect = styled(Select)`
    border-radius: 25px;
    min-width: 80px;
    color: white;
    height: 50px;
    margin-left: 50px;

    & .${inputBaseClasses.root} {
        margin-top: 0;
        flex-shrink: 0;
        height: 50px;
        width: 100%;
        border-radius: 25px;

        & > .${selectClasses.select} {
            padding: 10px 40px 10px 15px !important;
            color: white;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 18px;
            box-sizing: border-box;
        }

        & > .${selectClasses.icon} {
            color: white;
            margin-right: 10px;
            pointer-events: none;
        }
        &.${outlinedInputClasses.root} > .${outlinedInputClasses.notchedOutline} {
            border-color: ${({ theme }) => theme.palette.blue.lightest};
            border-width: 1px;
        }
    }
`;
